export const PLAYBACK_SKIP_TOAST_ID = 'rhythme-playback-skip';
export const PLAYBACK_SKIP_BURST_MS = 8000;

const IsolatedSkipMessage = 'That source became unavailable — finding another.';

let burstCount = 0;
let lastAt = 0;

export function resetPlaybackSkipToasts() {
  burstCount = 0;
  lastAt = 0;
}

export function playbackSkipToastMessage(count, isolatedMessage = IsolatedSkipMessage) {
  if (count <= 1) return isolatedMessage;
  return `${count} sources became unavailable — finding others.`;
}

/**
 * Presentation only. Playback skip/error handling stays with the caller.
 */
export function notifyPlaybackSkipToast(toastApi, isolatedMessage = IsolatedSkipMessage, now = Date.now()) {
  if (!lastAt || now - lastAt > PLAYBACK_SKIP_BURST_MS) {
    burstCount = 1;
  } else {
    burstCount += 1;
  }
  lastAt = now;
  toastApi.error(playbackSkipToastMessage(burstCount, isolatedMessage), {
    id: PLAYBACK_SKIP_TOAST_ID,
  });
  return burstCount;
}
